export enum CustomErrorCodes {
	SiteMissing = "User does not have an active site. Please contact an administrator to activate a site to proceed."
}
